import {createAction} from 'redux-actions';

import {OSM, Region, Route} from './actions';

/**
 * @param {String} layer
 */
export const changeLayer = createAction(OSM.Layer);

/**
 * @param {Boolean} colored
 */
export const changeColored = createAction(OSM.Colored);

/**
 * @param {Number} opacity
 */
export const changeOpacity = createAction(OSM.Opacity);

/**
 * @param {Boolean} enabled
 */
export const changeFAIEnabled = createAction(OSM.FAI);

const confirmRegionChangeAction = createAction(Region.confirmChange);

export const confirmRegionChange = id => (dispatch, getState) => {
    const {confirmRegionChange} = getState();

    if (confirmRegionChange) confirmRegionChange.confirm(false);

    return new Promise(resolve => {
        dispatch(confirmRegionChangeAction({
            id,
            confirm: abort => {
                resolve(abort);
                dispatch(confirmRegionChangeAction(null));
            },
        }));
    });
};

/**
 * @param {Number} startHour
 */
export const changeStartHour = createAction(Route.startHour);

/**
 * @param {Number} startMinute
 */
export const changeStartMinute = createAction(Route.startMinute);

/**
 * @param {String | null} arrivalTime
 */
export const changeArrivalTime = createAction(Route.arrivalTime);

/**
 * @param {String} plane
 */
export const changePlane = createAction(Route.plane);

/**
 * @param {Number} climbRate
 */
export const changeClimbRate = createAction(Route.climbRate);

/**
 * @param {Number} descentRate
 */
export const changeDescentRate = createAction(Route.descentRate);

/**
 * @param {Number} cruisingAltitude
 */
export const changeCruisingAltitude = createAction(Route.cruisingAltitude);

/**
 * @param {Number} cruisingSpeed
 */
export const changeCruisingSpeed = createAction(Route.cruisingSpeed);

/**
 * @param {String} skillLevel
 */
export const changeSkillLevel = createAction(Route.skillLevel);

/**
 * @param {Number} hourlyAverage
 */
export const changeHourlyAverage = createAction(Route.hourlyAverage);
